/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// ES6
import React, { useContext, useEffect, useState } from "react";

import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Snackbar,
  TextField,
  InputAdornment,
  IconButton,
  Checkbox,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  Menu,
} from "@material-ui/core/";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Chip from "@material-ui/core/Chip";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SettingsIcon from "@material-ui/icons/Settings";
import MultipleValueTextInput from "react-multivalue-text-input";

import axios from "axios";
import VisibilityIcon from "@material-ui/icons/Visibility";

import AccountTreeIcon from "@material-ui/icons/AccountTree";
import DeleteIcon from "@material-ui/icons/Delete";
import Table from "react-bootstrap/Table";

import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";
import { AppContext } from "../../../context";
import { RowSelectContext } from "../../../context/RowSelectContext";
import {
  getAllTrademark,
  getFilterTrademarkData,
  getSearchedTrademarkData,
  setWatchedTradmark,
  addTrademark,
  setKeywordsTrademark,
  setClassTrademark,
  setSpyPublications,
  deleteTrademark,
} from "./TrademarkService";
import PdfControl from "../PDF/PdfControl";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import LocalStorageService from "../../../LocalStorageService";

import Loader from "../../includes/Loader";

import MuiAlert from "@material-ui/lab/Alert";
import { Modal } from "react-bootstrap";

const localStorageService = LocalStorageService.getService();

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
let rowSelectedList = [];
const classeOption = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "99",
  "All",
];

let pageCountObj = 0;
let isNextClick = true;
const Trademarks = () => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const context = useContext(AppContext);
  const contextRowSelect = useContext(RowSelectContext);
  const { setComparisionPdfData } = context;
  let history = useHistory();
  const [trademarkData, setTrademarkData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentRowData, setCurrentRowData] = useState([]);

  const [rowSelectedData, setRowSelectedData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedValue, setSelectedValue] = useState("applicationNo");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteApplication, setDeleteApplication] = useState("");
  const [openDeleteMessage, setOpenDeleteMessage] = useState(false);
  const [openAddTrademarkMessage, setOpenAddTrademarkMessage] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState("");
  const [addTrademarkSuccess, setAddTrademarkSuccess] = useState("");
  const [filterWatched, setFilterWatched] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [toAddApplicationNo, setToAddApplicationNo] = useState("");
  const [isError, setIsError] = useState(false);

  const [applicationNoForSettings, setApplicationNoForSettings] = useState("");
  const [showKeywordsModal, setShowKeywordsModal] = useState(false);
  const [showClassModal, setShowClassModal] = useState(false);
  const [showSpyPublicationModal, setShowSpyPublicationModal] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [keywordsList, setKeywordsList] = useState([]);
  const [openError, setOpenError] = useState(false);
  const [errorMessageSnake, setErrorMessageSnake] = useState("");
  const [classesList, setClassesList] = useState([]);
  const [pageId, setPageId] = useState([]);
  const [endOfData, setEndOfData] = useState(false);
  const [openSuccessMessage, setOpenSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const closeErrorHandler = () => setOpenError(false);
  const openErrorHandler = () => setOpenError(true);

  const handleCloseDrawer = () => setAnchorEl(null);
  const handleOpenDrawer = async (appNo, event) => {
    setApplicationNoForSettings(appNo);
    setAnchorEl(event.currentTarget);
    const res = await getAllTrademark(
      localStorage.getItem("pageId")
        ? `&page=${localStorage.getItem("pageId")}`
        : ""
    );
    const tempData = [...trademarkData];

    const foundedClasses = res.Items.find(
      (t) => t.applicationNo === appNo
    ).compareClass;
    const foundedKeywords = res.Items.find(
      (t) => t.applicationNo === appNo
    ).keywords;
    console.log(foundedKeywords, "foundedKeywords");
    if (foundedClasses) {
      setClassesList(foundedClasses);
    }

    console.log(res, "resData");
    if (foundedKeywords) {
      setKeywordsList(foundedKeywords);
    } else {
      setKeywordsList([]);
    }
  };

  const handleCloseKeywordsModal = () => setShowKeywordsModal(false);
  const handleOpenKeywordsModal = () => {
    handleCloseDrawer();
    setShowKeywordsModal(true);
  };
  const handleCloseClassModal = () => setShowClassModal(false);
  const handleOpenClassModal = () => {
    handleCloseDrawer();
    setShowClassModal(true);
  };
  const handleCloseSpyPublicationsModal = () =>
    setShowSpyPublicationModal(false);
  const handleOpenSpyPublicationsModal = () => {
    handleCloseDrawer();
    setShowSpyPublicationModal(true);
  };
  const handleCloseModal = () => setShowModal(false);
  const handleOpenModal = () => setShowModal(true);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const closeHandlerSuccessMessage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSuccessMessage(false);
  };

  const handleValueChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleClickOpenConfirm = (applicationNo) => {
    setOpenConfirm(true);
    setDeleteApplication(applicationNo);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handlePageNextChange = () => {
    isNextClick = true;

    if (endOfData) {
      return;
    }

    getTrademarList(`&page=${pageId[pageCountObj]}`);

    localStorage.setItem("pageId", pageId[pageCountObj]);
    localStorage.setItem("totalPageId", JSON.stringify(pageId));
    pageCountObj++;
  };
  const handlePagePrevChange = () => {
    isNextClick = false;
    pageCountObj--;

    if (pageCountObj <= 0) {
      getTrademarList();
      localStorage.removeItem("pageId");
      setPageId([]);
      localStorage.removeItem("totalPageId");
      pageCountObj = 0;
      isNextClick = true;
    } else {
      getTrademarList(`&page=${pageId[pageCountObj - 1]}`);
    }
    const tempPageId = [...pageId];
    tempPageId.splice(pageCountObj + 1, 1);
    setPageId(tempPageId);
    setEndOfData(false);
  };
  const backToPageOneHandler = () => {
    getTrademarList();
    setPageId([]);
    pageCountObj = 0;
  };

  useEffect(() => {
    const { setRowSelectedDataContext } = contextRowSelect;
    const { setAuthVisible } = context;
    if (localStorageService.getToken()) {
      setAuthVisible(false);

      if (localStorage.getItem("pageId")) {
        getTrademarList(`&page=${localStorage.getItem("pageId")}`);
      } else {
        getTrademarList();
      }
    } else {
      history.push("/login");
    }
    return () => {
      setTrademarkData([]);
      setRowSelectedDataContext([]);
      rowSelectedList = [];
      setComparisionPdfData("myTrademarkPdfData", []);
      localStorage.removeItem("pageId");
      localStorage.removeItem("totalPageId");
      pageCountObj = 0;
      isNextClick = true;
    };
  }, []);

  // const handlePageChange = (event, value) => {
  //   setIsLoading(true)
  //   setPage(value)

  //   getTrademarList(value)
  // }

  const getTrademarList = async (pageObj) => {
    const res = await getAllTrademark(pageObj);

    const trademarkItems = res.Items;

    if (trademarkItems && trademarkItems.length > 0) {
      trademarkItems.forEach((element) => {
        if (element.spy === false) {
          element.isSpy = false;
        } else {
          element.isSpy = true;
        }
      });
      setTrademarkData(trademarkItems);

      setComparisionPdfData("myTrademarkPdfData", trademarkItems);
      setPageCount(res.Count);

      if (isNextClick) {
        setPageId((prevState) => [...prevState, res.PageId]);
        if (res.PageId) {
          setEndOfData(false);
        } else {
          setEndOfData(true);
        }
      }

      setIsLoading(false);
    } else {
      setTrademarkData([]);
      setIsLoading(false);
    }
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value.trim();

    setSearchQuery(searchValue);
    if (searchValue && searchValue.length > 0) {
    } else {
      setIsLoading(true);
      setCurrentRowData([]);
      getTrademarList();
      localStorage.removeItem("pageId");
      setPageId([]);
      localStorage.removeItem("totalPageId");
      pageCountObj = 0;
      isNextClick = true;
    }
  };

  const getSearchedData = async (valueObj) => {
    let isValid = false;
    const isNum = /^\d+$/.test(valueObj);
    if (!isNum && selectedValue === "applicationNo") {
      setOpen(true);
      setErrorMessage("Please enter number");
      isValid = false;
      return;
    } else if (isNum) {
      isValid = true;
    } else if (!isNum) {
      isValid = true;
    } else if (isNum && selectedValue === "mark") {
      setOpen(true);
      setErrorMessage("Please enter mark");
    }

    if (isValid) {
      setIsLoading(true);
      const resData = await getSearchedTrademarkData(selectedValue, valueObj);
      const publishedMark = resData.Items;

      if (publishedMark && publishedMark.length > 0) {
        setComparisionPdfData("myTrademarkPdfData", publishedMark);
        setTrademarkData(publishedMark);
        localStorage.removeItem("pageId");
        setPageId([]);
        localStorage.removeItem("totalPageId");
        pageCountObj = 0;
        isNextClick = true;
        setPageCount(resData.Count);
        setIsLoading(false);
      } else {
        setTrademarkData([]);
        setIsLoading(false);
      }
    }
  };

  const searchHandler = () => {
    getSearchedData(searchQuery);
  };

  const rowSelectHandler = (appNo, e) => {
    const { setRowSelectedDataContext } = contextRowSelect;

    if (e.target.checked) {
      const selectedRow = trademarkData.find(
        (p) => p.applicationNo === appNo.applicationNo
      );
      rowSelectedList.push({ ...selectedRow });

      setRowSelectedData(rowSelectedList);
      setRowSelectedDataContext(rowSelectedList);
    } else {
      const rowIndex = rowSelectedList.findIndex(
        (p) => p.applicationNo === appNo.applicationNo
      );
      rowSelectedList.splice(rowIndex, 1);
      setRowSelectedDataContext(rowSelectedList);
    }
  };

  const handleDeleteTrademark = async () => {
    const res = await deleteTrademark(deleteApplication);
    if (res) {
      setOpenConfirm(false);
      setOpenDeleteMessage(true);
      setDeleteSuccess("Trademark deleted successfully");
      const tempData = [...trademarkData];
      const founded = tempData.filter(
        (tr) => tr.applicationNo !== deleteApplication
      );
      setTrademarkData(founded);
      // getTrademarList();
    }
  };

  const closeDeleteMessageHandler = () => {
    setOpenDeleteMessage(false);
  };
  const closeAddTrademarkHandler = () => {
    setOpenAddTrademarkMessage(false);
  };

  const handleClickWatchHandler = async (appNo) => {
    const tempTrademark = trademarkData.find((p) => p.applicationNo === appNo);
    const { ceaseDesist } = tempTrademark;

    let isWatched = false;
    if (ceaseDesist) {
      isWatched = false;
    } else {
      isWatched = true;
    }
    let tempData = [...trademarkData];
    tempData.forEach((element) => {
      if (element.applicationNo === appNo) {
        element.ceaseDesist = isWatched;
      }
    });
    setTrademarkData(tempData);
    const res = await setWatchedTradmark(appNo, isWatched);
    if (res) {
      handleCloseDrawer();
    }

    // getTrademarList(page)
  };

  const handleChangeFilterWatched = async (e) => {
    const { value } = e.target;

    setFilterWatched(value);
    let type;
    if (value === "watch") {
      type = "watch";
    } else if (value === "all") {
      type = "all";
    }
    const res = await getFilterTrademarkData(type);

    if (res) {
      setTrademarkData(res.Items);
      localStorage.removeItem("pageId");
      setPageId([]);
      localStorage.removeItem("totalPageId");
      pageCountObj = 0;
      isNextClick = true;
      setPageCount(res.Count);
      setComparisionPdfData("myTrademarkPdfData", res.Items);
    }
  };

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const addTrademarHandler = async (e) => {
    console.log(toAddApplicationNo, "toAddApplicationNo");
    e.preventDefault();
    if (toAddApplicationNo === "") {
      setIsError(true);
      return;
    } else {
      setIsError(false);
    }

    const res = await addTrademark(
      toAddApplicationNo,
      localStorageService.getCompanyId()
    );
    setToAddApplicationNo("");
    handleCloseModal();
    setOpenAddTrademarkMessage(true);
    setAddTrademarkSuccess("New Trademark added successfully");

    console.log(res, "resData");
  };

  const keywordsSubmitHandler = async () => {
    if (keywordsList.length === 0) {
      openErrorHandler();
      setErrorMessageSnake("Please enter a keyword");
      return;
    }
    const res = await setKeywordsTrademark(
      applicationNoForSettings,
      keywordsList
    );

    if (res) {
      setOpenAddTrademarkMessage(true);
      setAddTrademarkSuccess(res.message);
      handleCloseKeywordsModal();
      // setKeywordsList([]);
      // getTrademarList();
    }

    console.log(res, "resData");
  };
  const classesSelectHandler = (value) => {
    console.log(value, "selected");
    setClassesList(value);
  };
  const classSubmitHandler = async () => {
    if (classesList.length === 0) {
      openErrorHandler();
      setErrorMessageSnake("Please select class");
      return;
    }
    const res = await setClassTrademark(applicationNoForSettings, classesList);

    if (res) {
      setOpenAddTrademarkMessage(true);
      setAddTrademarkSuccess(res.message);
      handleCloseClassModal();
      setClassesList([]);
      // getTrademarList();
    }

    console.log(res, "resData");
  };

  const handleClickSpyHandler = async (appNo) => {
    const tempTrademark = trademarkData.find((p) => p.applicationNo === appNo);
    const { isSpy } = tempTrademark;

    let isSpyTemp = false;
    if (isSpy) {
      isSpyTemp = false;
    } else {
      isSpyTemp = true;
    }
    let tempData = [...trademarkData];
    tempData.forEach((element) => {
      if (element.applicationNo === appNo) {
        element.isSpy = isSpyTemp;
      }
    });
    setTrademarkData(tempData);
    const res = await setSpyPublications(appNo, isSpyTemp);
    if (res) {
      setOpenSuccessMessage(true);
      handleCloseSpyPublicationsModal();
      setSuccessMessage(res.message);
    }

    console.log(res, "resData");
  };

  const loadingComponent = (
    <div
      style={{
        position: "fixed",
        zIndex: 110,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(255,255,255,0.8)",
      }}
    >
      <Loader />
    </div>
  );

  console.log(keywordsList, "keywordsList");

  const totalPageIdCount = JSON.parse(localStorage.getItem("totalPageId"));

  return (
    <>
      <div className="top_head_table">
        <div className="select_wrap" style={{ maxWidth: 180 }}>
          <FormControl variant="filled" fullWidth>
            <InputLabel id="demo-simple-select-outlined-label">
              Select Spy
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={filterWatched}
              onChange={handleChangeFilterWatched}
              label="Journal"
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="watch">Spy</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="search_wrap">
          <TextField
            id="filled-basic"
            label="Search"
            variant="filled"
            className="search_box"
            onChange={handleSearch}
            value={searchQuery}
            InputProps={{
              endAdornment: (
                <InputAdornment>
                  <IconButton onClick={searchHandler}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FormControl variant="filled" className="ml-1 select_column">
            <InputLabel id="demo-simple-select-label">Select column</InputLabel>
            <Select
              labelId="demo-simple-select-filled-label"
              id="demo-simple-select-filled"
              value={selectedValue}
              onChange={handleValueChange}
            >
              <MenuItem value="applicationNo">Application No</MenuItem>
              <MenuItem value="mark">Mark</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="pagination_wrap">
          {/* <Pagination
            count={pageCount}
            page={page}
            color='primary'
            onChange={handlePageChange}
          /> */}
          <ul>
            {totalPageIdCount?.length > 0 && (
              <>
                {" "}
                <li>
                  <IconButton
                    aria-label="delete"
                    onClick={backToPageOneHandler}
                  >
                    <FirstPageIcon fontSize="large" />
                  </IconButton>
                </li>
                <li className="d-block">
                  <IconButton
                    aria-label="delete"
                    onClick={handlePagePrevChange}
                  >
                    <NavigateBeforeIcon fontSize="large" />
                  </IconButton>
                </li>
              </>
            )}

            <li className={endOfData ? "no_next" : ""}>
              {" "}
              <IconButton aria-label="delete" onClick={handlePageNextChange}>
                <NavigateNextIcon fontSize="large" />
              </IconButton>
            </li>
          </ul>
        </div>
      </div>
      {isLoading && loadingComponent}
      <div className="table_body_wrap">
        <div className="title_head">
          <h5>Trademarks</h5>
          <PdfControl
            exportToCSV={exportToCSV}
            searchedData={currentRowData}
            rowSelectedData={rowSelectedData}
            fromMyTrademark
            handleOpenModal={handleOpenModal}
          />
        </div>

        <Table bordered size="sm">
          <thead>
            <tr>
              <th></th>
              <th>Application No</th>
              <th>Name</th>
              <th>Class</th>
              <th>Applicant Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {trademarkData.length > 0 ? (
              <>
                {trademarkData.map((word, i) => (
                  <tr
                    key={i}
                    className={`${word.ceaseDesist ? "watched_row" : ""}`}
                  >
                    <td style={{ width: "35px" }}>
                      <Checkbox
                        color="primary"
                        checked={rowSelectedList.some((p) =>
                          p.applicationNo === word.applicationNo ? 1 : 0
                        )}
                        onClick={(e) => rowSelectHandler(word, e)}
                        inputProps={{ "aria-label": "uncontrolled-checkbox" }}
                      />
                    </td>
                    <td>{word.applicationNo}</td>
                    <td>
                      <strong>{word.name}</strong>{" "}
                      {word.url && (
                        <img className="logo_mark" alt="" src={word.url} />
                      )}
                    </td>
                    <td>{word.class}</td>
                    <td>{word.applicantName}</td>
                    <td>
                      <IconButton
                        aria-label="delete"
                        onClick={(e) =>
                          //
                          handleOpenDrawer(word.applicationNo, e)
                        }
                      >
                        <SettingsIcon
                          // className={`${
                          //   word.ceaseDesist ? 'watched' : 'not_watched'
                          // }`}
                          fontSize="medium "
                          className="text-primary"
                        />
                      </IconButton>
                      <IconButton
                        aria-label="delete"
                        onClick={() =>
                          handleClickOpenConfirm(word.applicationNo)
                        }
                      >
                        <DeleteIcon
                          fontSize="medium "
                          className="text-danger"
                        />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="8">Sorry no record found!</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <Dialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Do you really want to delete?"}
        </DialogTitle>

        <DialogActions>
          <Button onClick={handleCloseConfirm} color="primary">
            No
          </Button>
          <Button onClick={handleDeleteTrademark} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openDeleteMessage}
        autoHideDuration={6000}
        onClose={closeDeleteMessageHandler}
      >
        <Alert onClose={closeDeleteMessageHandler} severity="success">
          {deleteSuccess}
        </Alert>
      </Snackbar>
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Trademark</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={addTrademarHandler} noValidate autoComplete="off">
            <p>
              <TextField
                type="text"
                id="filled-basic"
                label="Application No."
                variant="filled"
                fullWidth
                onChange={(e) => setToAddApplicationNo(e.target.value)}
                required
                error={isError}
                helperText={
                  isError
                    ? "Please Enter Application No"
                    : "Enter comma after 6 or 7 digits "
                }
              />
            </p>
            <Button variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </form>
        </Modal.Body>
      </Modal>
      <Snackbar
        open={openSuccessMessage}
        autoHideDuration={6000}
        onClose={closeHandlerSuccessMessage}
      >
        <Alert onClose={closeHandlerSuccessMessage} severity="success">
          {successMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openAddTrademarkMessage}
        autoHideDuration={6000}
        onClose={closeAddTrademarkHandler}
      >
        <Alert onClose={closeAddTrademarkHandler} severity="success">
          {addTrademarkSuccess}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={closeErrorHandler}
      >
        <Alert onClose={closeErrorHandler} severity="error">
          {errorMessageSnake}
        </Alert>
      </Snackbar>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseDrawer}
      >
        <MenuItem onClick={handleOpenClassModal}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="24"
            height="24"
            x="0"
            y="0"
            viewBox="0 0 511.797 511.797"
            className="MuiSvgIcon-root mr-3"
          >
            <g>
              <script></script>
              <g xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m255.899 511.797c-12.406 0-22.5-10.093-22.5-22.5 0-9.778 6.27-18.12 15-21.215v-79.899c-16.182-.496-31.144-2.582-45-5.829v28.092c0 4.142-3.357 7.5-7.5 7.5h-32.5v19.934c8.73 3.095 15 11.437 15 21.215 0 12.407-10.094 22.5-22.5 22.5s-22.5-10.093-22.5-22.5c0-9.778 6.27-18.12 15-21.215v-27.434c0-4.142 3.357-7.5 7.5-7.5h32.5v-24.672c-36.894-11.454-65.257-30.911-87.578-48.664-3.241-2.578-3.779-7.296-1.201-10.538 2.579-3.242 7.295-3.779 10.539-1.201 15.546 12.364 34.176 25.604 56.781 36.042-26.729-24.258-43.541-59.261-43.541-98.115 0-38.827 16.788-73.808 43.485-98.064-34.104 15.717-59.783 37.978-79.6 55.159-17.737 15.377-30.989 29.085-38.984 37.877-2.606 2.866-2.606 7.189 0 10.056 7.995 8.792 21.248 22.5 38.984 37.876 3.13 2.713 3.467 7.45.754 10.58-2.714 3.131-7.451 3.466-10.58.754-18.292-15.859-31.988-30.027-40.256-39.119-7.838-8.62-7.838-21.62 0-30.239 8.268-9.093 21.963-23.26 40.256-39.12 20.827-18.057 43.535-36.938 71.908-51.909 10.149-5.355 20.41-9.879 30.841-13.585l-29.612-29.612c-1.406-1.406-2.196-3.314-2.196-5.303v-27.434c-8.73-3.095-15-11.437-15-21.215 0-12.407 10.094-22.5 22.5-22.5s22.5 10.093 22.5 22.5c0 9.778-6.27 18.12-15 21.215v24.328l32.97 32.969c16.781-4.541 34.053-7.057 52.03-7.602v-79.695c-8.73-3.095-15-11.437-15-21.215 0-12.407 10.094-22.5 22.5-22.5s22.5 10.093 22.5 22.5c0 9.778-6.27 18.12-15 21.215v79.695c15.477.469 30.433 2.399 45 5.824v-28.085c0-4.142 3.357-7.5 7.5-7.5h32.5v-19.934c-8.73-3.095-15-11.437-15-21.215 0-12.407 10.094-22.5 22.5-22.5s22.5 10.093 22.5 22.5c0 9.778-6.27 18.12-15 21.215v27.434c0 4.142-3.357 7.5-7.5 7.5h-32.5v24.683c13.265 4.137 26.237 9.566 39.032 16.317 28.373 14.971 51.081 33.853 71.908 51.91 18.292 15.859 31.988 30.026 40.256 39.119 7.838 8.62 7.838 21.62 0 30.239-8.268 9.093-21.963 23.26-40.256 39.12-20.827 18.057-43.535 36.939-71.908 51.909-10.149 5.355-20.41 9.879-30.841 13.585l29.612 29.612c1.406 1.406 2.196 3.314 2.196 5.303v27.434c8.73 3.095 15 11.437 15 21.215 0 12.407-10.094 22.5-22.5 22.5s-22.5-10.093-22.5-22.5c0-9.778 6.27-18.12 15-21.215v-24.328l-32.97-32.969c-16.781 4.541-34.053 7.057-52.03 7.602v79.898c8.73 3.095 15 11.437 15 21.215.001 12.406-10.093 22.499-22.499 22.499zm0-30c-4.136 0-7.5 3.364-7.5 7.5 0 4.135 3.364 7.5 7.5 7.5s7.5-3.365 7.5-7.5-3.365-7.5-7.5-7.5zm100-30.202c-4.136 0-7.5 3.364-7.5 7.5s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5-3.365-7.5-7.5-7.5zm-200 0c-4.136 0-7.5 3.364-7.5 7.5s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5-3.365-7.5-7.5-7.5zm100-78.298c64.79 0 117.5-52.71 117.5-117.5 0-24.719-7.586-48.366-21.939-68.385-2.413-3.366-1.641-8.052 1.726-10.465 3.364-2.413 8.051-1.642 10.466 1.725 16.19 22.583 24.748 49.252 24.748 77.125 0 38.827-16.788 73.808-43.485 98.064 34.104-15.717 59.783-37.978 79.6-55.159 17.737-15.377 30.989-29.085 38.984-37.877 2.606-2.866 2.606-7.189 0-10.056-7.995-8.792-21.248-22.5-38.984-37.876-34.262-29.705-86.039-74.595-168.614-74.595-64.79 0-117.5 52.71-117.5 117.5s52.708 117.499 117.498 117.499zm100-328.297c-4.136 0-7.5 3.365-7.5 7.5 0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-4.135-3.365-7.5-7.5-7.5zm-200 0c-4.136 0-7.5 3.365-7.5 7.5 0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-4.135-3.365-7.5-7.5-7.5zm100-30c-4.136 0-7.5 3.365-7.5 7.5 0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-4.135-3.365-7.5-7.5-7.5zm-102.5 240.797c0-56.508 45.965-102.483 102.469-102.5h.057c-.019 0-.077 0-.057 0 56.504.017 102.469 45.992 102.469 102.5s-45.965 102.483-102.469 102.5h.057c-.019 0-.036 0-.057 0-56.504-.016-102.469-45.991-102.469-102.5zm38.47 59.578c15.382 16.521 37.058 27.101 61.174 27.877 8.806-8.261 22.249-23.716 30.257-46.648-35.163 21.574-68.658 22.332-91.431 18.771zm113.07-62.905c1.104 41.292-15.025 70.696-29.512 88.631 23.029-5.27 42.625-19.65 54.774-39.134-2.755-11.76-9.42-31.112-25.262-49.497zm-126.188 44.587c11.57 3.497 31.698 7.409 55.576 2.862-21.563-11.769-39.122-28.169-51.417-48.18-2.168-3.529-1.064-8.148 2.465-10.316 3.527-2.168 8.148-1.064 10.316 2.464 3.3 5.372 7.035 10.455 11.172 15.222-1.088-41.295 15.051-70.702 29.513-88.616-38.882 8.894-67.978 43.765-67.978 85.305.001 14.909 3.75 28.96 10.353 41.259zm44.432-22.396c9.658 7.631 20.66 14.002 32.784 18.936 10.611-4.222 21.621-10.331 32.701-18.957 1.648-11.301 1.864-23.891-.066-37.8-8.962-7.078-19.759-13.56-32.77-18.843-10.608 4.222-21.618 10.33-32.695 18.952-1.647 11.275-1.867 23.841.046 37.712zm54.353-62.997c36.31 19.689 53.711 48.359 62.001 69.871 2.509-8.14 3.861-16.785 3.861-25.737 0-14.91-3.749-28.96-10.353-41.259-11.56-3.495-31.657-7.405-55.509-2.875zm-18.781-43.321c-8.773 8.233-22.229 23.688-30.247 46.642 35.16-21.568 68.649-22.325 91.42-18.765-15.38-16.519-37.062-27.098-61.173-27.877z"
                  fill="#1834c6"
                  data-original="#000000"
                ></path>
              </g>
            </g>
          </svg>{" "}
          Spy New Applications
        </MenuItem>
        <MenuItem onClick={handleOpenSpyPublicationsModal}>
          <VisibilityIcon className="text-danger mr-3" /> Spy New Publications
        </MenuItem>
        <MenuItem onClick={handleOpenKeywordsModal}>
          <AccountTreeIcon className="text-primary mr-3" />
          Keywords
        </MenuItem>
        {/* <MenuItem onClick={handleOpenClassModal}>Class</MenuItem> */}
      </Menu>

      <Modal
        show={showKeywordsModal}
        onHide={handleCloseKeywordsModal}
        centered
        size="lg"
        className="keywords_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Keywords</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MultipleValueTextInput
            onItemAdded={(item, allItems) => {
              setKeywordsList((prevState) => {
                console.log(prevState, "prevState");
                let itmesTemp;
                if (prevState) {
                  itmesTemp = [...prevState, item];
                }
                return itmesTemp;
              });
              console.log(`Item added: ${item}`);
            }}
            onItemDeleted={(item, allItems) => {
              const tempData = [...keywordsList];

              const index = tempData.indexOf(item);
              tempData.splice(index, 1);
              setKeywordsList(tempData);

              console.log(`Item removed: ${item}`);
            }}
            name="item-input"
            placeholder="Enter keywords, separate them with COMMA or ENTER."
            values={keywordsList}
          />
          <p>
            <small>Enter keywords, separate them with COMMA or ENTER.</small>
          </p>
          <Button
            color="primary"
            variant="contained"
            className="mt-3"
            onClick={keywordsSubmitHandler}
          >
            Submit
          </Button>
        </Modal.Body>
      </Modal>
      <Modal
        show={showClassModal}
        onHide={handleCloseClassModal}
        centered
        className="keywords_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Spy for New Applications</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormControlLabel
            control={
              <Switch
                checked={trademarkData.some((p) => {
                  let isTrue;
                  if (p.applicationNo === applicationNoForSettings) {
                    if (p.ceaseDesist) {
                      isTrue = true;
                    } else {
                      isTrue = false;
                    }
                  }
                  return isTrue;
                })}
                onChange={() =>
                  handleClickWatchHandler(applicationNoForSettings)
                }
                name="watch"
                color="primary"
              />
            }
            label="Spy"
          />
          <hr />
          <Autocomplete
            multiple
            id="tags-filled"
            options={classeOption.map((option) => option)}
            onChange={(e, newValue) => classesSelectHandler(newValue)}
            defaultValue={classesList}
            freeSolo
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="filled"
                label="Classes"
                placeholder="Add Classes"
              />
            )}
          />
          <Button
            color="primary"
            variant="contained"
            className="mt-3"
            onClick={classSubmitHandler}
          >
            Submit
          </Button>
        </Modal.Body>
      </Modal>
      <Modal
        show={showSpyPublicationModal}
        onHide={handleCloseSpyPublicationsModal}
        centered
        className="keywords_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Spy for New Publications</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormControlLabel
            control={
              <Switch
                checked={trademarkData.some((p) => {
                  let isTrue;
                  if (p.applicationNo === applicationNoForSettings) {
                    if (p.isSpy) {
                      isTrue = true;
                    } else {
                      isTrue = false;
                    }
                  }
                  return isTrue;
                })}
                onChange={() => handleClickSpyHandler(applicationNoForSettings)}
                name="watch"
                color="primary"
              />
            }
            label="Spy"
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Trademarks;
